import React from "react";
import AlvComponentModel from 'components/Models/AlvComponent/AlvComponent';
import PropTypes from "prop-types";
import "./AlvDividendsTableBlock.scss";

const AlvDividendsTableBlock = ({ language, heading, anchorId }) => {
    return (
        <div className="alv-dividents-table-block" id={anchorId}>
            <div className="alv-dividents-table-block__container">
                {heading && <h2 className="alv-dividents-table-block__heading">{heading}</h2>}
                <investor-dividends lang={language}></investor-dividends>
            </div>
        </div>
    );
};

AlvDividendsTableBlock.propTypes = Object.assign({}, AlvComponentModel.propTypes, {
    heading: PropTypes.string,
    anchorId: PropTypes.string
});

export default AlvDividendsTableBlock;


// WEBPACK FOOTER //
// ./src/components/AlvDividendsTableBlock/AlvDividendsTableBlock.jsx